// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"21d30032","667":"10adc900","885":"3db9eddd"}[chunkId] + ".chunk.js";
};